<ng-container *ngIf="visible">
  <button
    type="button"
    class="skynetix-trigger"
    [attr.aria-label]="'SkynetiX Assistent'"
    (click)="open()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  </button>

  <kendo-window
    *ngIf="opened"
    title="SkynetiX Assistent"
    [width]="480"
    [height]="640"
    [minWidth]="320"
    [draggable]="true"
    [resizable]="true"
    (close)="close()"
  >
    <iframe
      *ngIf="embedUrl && !errored"
      [src]="embedUrl"
      sandbox="allow-scripts allow-same-origin allow-forms"
      class="skynetix-iframe"
    ></iframe>

    <div *ngIf="loading" class="skynetix-status">
      <span class="skynetix-status__spinner"></span>
    </div>

    <div *ngIf="errored && !loading" class="skynetix-status skynetix-status--error">
      {{ errorMessage || 'SkynetiX Assistent ist derzeit nicht verfügbar.' }}
    </div>
  </kendo-window>
</ng-container>
